import React from "react";
import { Route } from "react-router";
import BlockPage from "./BlockPage";

const RouterBlocks = () => {
  return <Route exact path="/blocks/:id?" name="Block" component={BlockPage} />;
};

export default RouterBlocks;
